module.exports = __webpack_public_path__ + "img/image_ot-peru-salaverry_tanks2_1920px.6abe8cb3.jpg";